<template>
  <div class="wrapper">
    <RetinaImage
      class="logo"
      width="140"
      src="/img/logo-horizontal.png"
    />

    <slot />
  </div>
</template>

<script>
  import RetinaImage from '@/components/RetinaImage'

  export default {
    components: {
      RetinaImage,
    },
  }
</script>

<style lang="scss">
  @import "@/styles/_variables.scss";
  @import "@/styles/_reset.scss";
  @import "@/styles/_general.scss";

  .wrapper {
    padding: 60px 20px;
    max-width: 1000px;
    width: 100%;
    margin: auto;
  }

  .logo {
    height: auto;
    margin-bottom: 60px;
  }
</style>
